import { render, staticRenderFns } from "./Partner.vue?vue&type=template&id=4b735e91&scoped=true"
import script from "./Partner.vue?vue&type=script&lang=ts"
export * from "./Partner.vue?vue&type=script&lang=ts"
import style0 from "./Partner.vue?vue&type=style&index=0&id=4b735e91&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4b735e91",
  null
  
)

export default component.exports